export default "__VITE_ASSET__BZMGx$Kc__"